import React, { useState, useRef, useEffect } from 'react';
import Icon from './Icon';
import './ActionMenu.css';

/**
 * ActionMenu - Menú desplegable de tres puntos con acciones
 *
 * @param {Array} actions - Array de objetos con estructura:
 *   {
 *     label: string,
 *     onClick: function,
 *     icon: string (optional),
 *     variant: 'default' | 'danger' | 'warning' | 'success' (optional),
 *     disabled: boolean (optional)
 *   }
 */
function ActionMenu({ actions }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  // Cerrar menú al hacer click fuera
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleActionClick = (action) => {
    if (!action.disabled) {
      action.onClick();
      setIsOpen(false);
    }
  };

  return (
    <div className="action-menu" ref={menuRef}>
      <button
        type="button"
        className="action-menu-trigger"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Abrir menú de acciones"
      >
        <Icon name="more_vert" size="medium" />
      </button>

      {isOpen && (
        <div className="action-menu-dropdown">
          {actions.map((action, index) => (
            <button
              type="button"
              key={index}
              className={`action-menu-item ${action.variant || 'default'} ${
                action.disabled ? 'disabled' : ''
              }`}
              onClick={() => handleActionClick(action)}
              disabled={action.disabled}
            >
              {action.icon && <Icon name={action.icon} size="small" className="action-icon" />}
              <span className="action-label">{action.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ActionMenu;
